import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import B2BvsB2C from './components/B2BvsB2C';
import ProblemsSolved from './components/ProblemsSolved';
import WhyB2BDealsLost from './components/WhyB2BDealsLost';
import ProgramRoadmap from './components/ProgramRoadmap';
import SkillsLearned from './components/SkillsLearned';
import WhyProgramsWork from './components/WhyProgramsWork';
import CaseStudies from './components/CaseStudies';
import SuitableCompanies from './components/SuitableCompanies';
import StrongB2BSeller from './components/StrongB2BSeller';
import ProjectFlow from './components/ProjectFlow';
import CompanyResults from './components/CompanyResults';
import CTASection from './components/CTASection';
import WhyAlexeySivko from './components/WhyAlexeySivko';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';

const seoNavLinks = [
  { label: 'Программа', target: 'program' },
  { label: 'Кейсы', target: 'cases' },
  { label: 'Цены', target: 'contact' },
  { label: 'FAQ', target: 'faq' },
];

export default function B2BSalesTrainingPage() {
  return (
    <>
      
      <SeoTitle title="Тренинг по продажам B2B | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={seoNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <B2BvsB2C />
        <ProblemsSolved />
        <WhyB2BDealsLost />
        <ProgramRoadmap />
        <SkillsLearned />
        <WhyProgramsWork />
        <CaseStudies />
        <SuitableCompanies />
        <StrongB2BSeller />
        <ProjectFlow />
        <CompanyResults />
        <CTASection />
        <WhyAlexeySivko />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}